import NoResultBanner from './NoResultBanner.component';

export default NoResultBanner;
